// extracted by mini-css-extract-plugin
module.exports = {"cat-c-list":"product-quick-view-drawer_cat-c-list__m1c25","product-warning-tooltip-msg":"product-quick-view-drawer_product-warning-tooltip-msg__OPMCx"};